export default {
    blocksAvailable:[],
    blocksAvailableResume:{},
    propertiesAvailable:[],
    propertiesAvailableBackup:[],
}
